const zh = {
	options: {
		pendingAppeal: '待处理',
		waiting: '等待银行反馈',
		closed: '已结案',
		searchID: '搜索网站订单号',
		originID: '网站订单号',
		omniOriginID: '商户订单号',
		website: '来源网站',
		omniWebsite: '来源',
		chargebackStatus: '拒付进度',
		chargebackType: '类型',
		all: '全部',
		retrieval: '调单',
		Chargeback1st: '首次拒付',
		Chargeback2nd: '二次拒付',
		prearbitration: '预仲裁',
		reason: '拒付原因',
		allReason: '全部拒付原因',
		notdescribed: '货不对板',
		notReceived: '未收到货',
		fraud: '欺诈',
		others: '其他',
		download: '导出当前结果',
		originalOrderIDWebsite: '网站订单号/网站',
		omniOriginalOrderIDWebsite: '商户订单号/门店/网站',

		updateTime: '状态更新时间',
		deadline: '处理截止时间',
		lessthandays: '不足三天',
		retrievalChargebackAmount: '调单/拒付金额',
		operation: '操作',
		details: '详情',
		total: '共',
		nocases: '当前没有待处理调单拒付申请',
		noResult: '没有搜索到对应订单的调单拒付信息',
		appealResults: '申诉结果',
		time: '时间',
		currentStatus: '当前状态',
		exportResults: '导出当前结果',
		allwebsite: '全部网站',
		omniAllwebsite: '全部网站/门店',
		allstatus: '全部状态',
		allResult: '全部结果',
		chargebackTime: '拒付时间',
		closeDate: '结案时间',
		status: '状态',
		startTime: '开始日期',
		endTime: '结束日期',
		to: '至',
		storeGroup: '网站/群组',
		omniStoreGroup: '门店/网站/群组',
		groupName: '群组',
		allGroup: '所有群组',
		operatorName: '操作员',
		chargebackId: '拒付单号',
		placeHolder: '请输入内容',
		chargebackIdo: '单号',
		chargebackProtect: '拒付保护'
	},
	chargeBackDetail: {
		pendingAppealList: '待处理列表',
		retrievalDetail: '调单',
		chargebackDetail: '拒付',
		retrievalDate: '调单日期',
		creationTime: '创建时间',
		retrievalAmount: '调单金额',
		cardAssociation: '卡组织',
		comment: '备注',
		file: '文件',
		reason: '原因',
		originalTransactionInformation: '原始订单信息',
		websiteURL: '网站URL',
		originalOrderID: '原始商户订单号',
		transactionID: '交易流水号',
		itemName: '货运信息',
		amount: '交易金额',
		transactionTime: '原始交易时间',
		shippingName: '收货人姓名',
		clientEmail: '用户邮箱',
		shippingPhoneNumber: '收货人联系电话',

		order: '事件顺序',
		reorder: '事件倒序',
		retrievalProcess: '调单进程',
		chargebackProcess: '拒付进程',
		bankNotify: '银行调单通知创建，调单金额为 ',
		bankNotify2nd: '您已提交调单申诉，等待银行回应',
		bankNotify4nd: '您已提交拒付申诉，等待银行回应',
		bankNotify3rd: '您的申诉资料可优化，请重新提交',
		waivedCase: '您已放弃申诉，等待银行回应',
		expiredCase: '申诉时间过期，您已放弃申诉，等待银行回应',
		bankNotify4th: '银行首次拒付通知创建，拒付金额为 ',
		bankNotifyretrieval: '银行拒付通知创建，调单金额为 ',
		failedRetrievalCase: '调单申诉失败',

		highText: '申诉成功概率较高，强烈建议申诉，请按照页面提示尽可能完善材料',
		midText: '申诉成功概率一般，建议申诉，请按照页面提示尽可能完善材料',
		lowText: '申诉成功概率较低，可尝试申诉，请按照页面提示尽可能完善材料',
		statement: '申诉成功概率展示只是对争议/拒付结果的预估，并不能保证任何实际结果。如果有任何疑问请联系PingPong Checkout。',
		statusLabel: '胜率评估',

		cardHolderCancelled: '持卡人撤回申请，申诉成功',
		chargeback2nd: '银行发出二次拒付通知',
		cardHolderConfirmed: '持卡人确认预仲裁，请您回应',
		confirmedArbitration: '您已确认预仲裁，等待银行回应',
		arbitrationFailed: '银行仲裁结果：申诉失败',
		noneedArbitration: '此笔交易已退款，无需申诉',
		bankFeedbackSuccess: '银行反馈结果：申诉成功',
		bankFeedbackFailed: '银行仲裁结果：申诉失败',
		bankFeedbackPending: '您已进入仲裁阶段，等待银行回应。',

		waive: '放弃申诉',
		appealNow: '我要申诉',
		editMaterial: '修改申诉材料',
		respondRetrieval: '收到银行调单通知，请您回应',
		respondedRetrieval: '您已回应银行调单通知，请耐心等待银行返回结果',
		issuesInfo: '您的资料存在以下问题，请修改后重新提交',
		waivedIssues: '您已放弃申诉，请耐心等待银行返回结果',
		expiredWaive: '您未在规定时间内申诉，被视为放弃，请耐心等待银行返回结果',

		chargebackCase1st: '收单银行首次拒付通知，请您回应',
		respond1stChargeback: '您已回应银行首次拒付通知，请耐心等待银行返回结果',
		chargebackCase2nd: '收单银行二次拒付通知，请您回应',
		respond2ndChargeback: '您已回应银行二次拒付通知，请耐心等待银行返回结果',
		resondCardHolderConfirmed: '持卡人确认预仲裁，请您回应',
		lessThen3days: '不足三天',
		lessThen3daysFont: '请在',
		lessThen3daysAffect: '前做出响应，过期将视为放弃申诉',
		lessThen3daysEnd: '仲裁是失败一方将承担仲裁费用',
		comfirmedArbitration: '您已确认预仲裁，请耐心等待银行返回结果',
		failedArbitration: '银行仲裁结果为：拒付有效，申诉失败',
		arbitrationSuccess: '银行仲裁结果为：申诉成功',
		cancelChargeback: '持卡人撤回拒付请求',
		noneedAppeal: '此笔交易已退款，无需申诉',
		bankArbitrationSuccess: '银行反馈结果为：申诉成功',
		bankArbitrationPartialSuccess: '银行反馈结果为：部分胜诉',
		bankArbitrationFailed: '银行反馈结果为：申诉失败',
		cancel: '取消',
		confirmedPreArbitration: '确认预仲裁',
		confirm: '确认',
		date: '日期',
		amountT: '金额',
		noEmoji: '请不要输入表情包',
		chargebackProtect: '拒付保护中'
	},
	form: {
		retrievalAppeal: '调单申诉',
		chargebackAppeal: '拒付申诉',
		uploadTips: '上传图片要求：请确保 ',
		uploadTips2nd: '上传资料图片文字清晰可见',
		uploadTips3rd: '最大不超过5M，格式限定为JPG、JPEG、PNG、BMP。',
		transactionInformation: '交易信息',
		itemName: '商品名称',
		receiverName: '收货人姓名',
		receiverPhone: '收货人电话',
		ShippingAddress: '收货地址',
		transactionInformationScreenshot: '店铺后台交易信息截图',
		addapic: '添加图片',
		shippingInformation: '货运信息',
		shippingCompany: '货运公司',
		trackingNumber: '物流订单号',
		thewaybillInformationScreenshot: '运单信息截图',
		imagesOfMerchandise: '商品图片',
		DescriptionGoods: '商品图片及详细说明',
		Imageofdelivered: '实际发出的商品图片',
		cardholdersSigned: '持卡人提供的争议已经撤销的证明，如有请提供',
		customerContactInformation: '商户与用户之间的沟通记录，请尽量提供',
		ReasonsAppeal: '商户进行申诉驳斥的理由和要点',
		reasonsAndPoints: '理由和要点',
		feedbacksOfgoods: '该商品历史买家好评，如有请提供',
		proofOfdelivery: '妥投证明，如有签收照片或签字一并提供',
		cancellationAndRefundPolicy: '商户的取消/退货&退款政策',
		transportationPolicy: '商户运输政策',
		submit: '提交',
		save: '暂存，稍后提交',

		submitTips: '请至少填写一项信息',
		submitSuccess: '提交成功',
		saveSuccess: '暂存成功',
		forgo: '您已放弃申诉',
		netError: '网络拥挤，请稍后重试！',
		select: 'Please select',
		waiveAppeal: '您确定要放弃申诉吗？放弃后将无法再次提出申诉，请谨慎决定。',
		chargebackConfirm:
      '拒付将进入仲裁阶段，因此产生的仲裁手续费500USD将由仲裁失败方承担，是否确认？',
		waitAmins: '支付请求已发起，请在原支付页面继续支付或等待15分钟后重新支付',

		noticeSuccessConfirm: '您已成功确认预仲裁',
		noticeFaildAppeal: '您已放弃申诉',
		orderClipboard: '订单号已复制到剪贴板',
		noticeCopyFailed: '复制失败，请重新尝试',
		noData: '当前没有等待银行反馈的调单拒付申请',
		noData2nd: '当前没有已结案的调单拒付申请',
		uploadFailed: '文件上传失败，请重新上传',
		imageLimited: '图片最多上传{max}张',
		uoloadLimited: '上传的文件最多不能超过{max}M!'
	}
}

export default zh
